import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { EnableCookiesDialogData } from '../dialogs-data/enable-cookies-dialog-data';
import { EnableCookiesDialogComponent } from '../dialogs/enable-cookies-dialog/enable-cookies-dialog.component';

@Injectable()
export class EnableCookiesDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<EnableCookiesDialogComponent>;

    open(enableCookiesDialogData: EnableCookiesDialogData) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '50%';
        matDialogConfig.data = enableCookiesDialogData;
        matDialogConfig.disableClose = false;
        matDialogConfig.hasBackdrop = true;
        this.matDialogRef = this.dialog.open(EnableCookiesDialogComponent, matDialogConfig);
    }

}
